import { useEffect, useState, useMemo } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';


//import './FT.css';
import { useParams } from 'react-router-dom';
import * as moment from 'moment'

const modeloDatos = {
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    clienteID: 0,
    nombreCliente: "",
    rnc: "",
    tipoComprobante: "",
    ncf: "",
    fecha: new Date,
    comentario: "",
    estatus: 0
}
const modeloDatos1 = {
    pedidoLineaID: 0,
    pedidoID: 0,
    empresaID: 0,
    numeroUnico: 0,
    articuloID: 0,
    descripcionArticulo: "",
    telefono: "",
    almacenID: 0,
    cantidad: 0,
    costo: 0.00,
    precio: 0.00,
    totalLinea: 0.00,
    fecha: new Date
}
const modeloDatosc = {
    clienteID: 0,
    empresaID: 1,
    descripcion: "",
    rnc: "",
    direccion: "",
    telefono: "",
    correo: ""


}

var SubTotal = 0.00;
var totalDescuento = 0.00;
var totalITBIS = 0.00;
var totalPago = 0.00;
var impresion = '';
var Leatendio = '';

let emp = 0;
const ImpresionFactura = () => {
    let { Pedido } = useParams();
   


    const [ListadoLineas, SetListadoLineas] = useState([modeloDatos1]);
    const [Listado, SetListado] = useState([modeloDatos]);
    const [ListadoClientes, SetListadoClientes] = useState([modeloDatosc]);
    const [Empresa, SetEmpresa] = useState([]);
    const [SN, SetSN] = useState();
    const [VerFactura, SetVerFactura] = useState(true);
    const [VerImprimir, SetVerImprimir] = useState(false);
    const [imageSrc, setImageSrc] = useState("");

    emp = JSON.parse(localStorage.getItem("sesion_usuario")).empresaID;

    useEffect(() => {
        obtenerDatos(Pedido)
       
        fetchImage()
    }, [])

 
    const obtenerDatosSN = async (e) => {
        let response = await fetch(Api + "Administracion/SecuenciaNumerica");
        if (response.ok) {
            let data = await response.json();
            var d = data.filter(x => x.secuenciaID == parseInt(e)).map(x => x.descripcion);
            SetSN(d)
        }
    }
    const [menuPosition, setMenuPosition] = useState(false);

    const handleContextMenu = (event) => {
        event.preventDefault();
        setMenuPosition({
            x: event.pageX,
            y: event.pageY,
        });
    };

    let items = [
        // { description, quantity, unit, unitPrice, discountPercent }
        { description: "Servicio/Producto 1", quantity: 1, unit: "unidad", unitPrice: 12345, discountPercent: 0 },
        { description: "Material 2", quantity: 5, unit: "m²", unitPrice: 2000, discountPercent: 5 },
    ];
    let taxRate = 0.18;         // ITBIS 18%
    let currency = "DOP";  

    const styles = `
    :root{
      --primary:#0d6efd; --text:#1f2937; --muted:#6b7280;
      --border:#e5e7eb; --bg:#ffffff; --stripe:#f9fafb;
    }
    *{box-sizing:border-box}
    body{ -webkit-print-color-adjust:exact; print-color-adjust:exact; }
    .page{ max-width:900px; margin:24px auto; padding:28px; background:#fff; border:1px solid var(--border); border-radius:12px; color:var(--text); font:14px/1.5 system-ui,-apple-system,Segoe UI,Roboto,Ubuntu,'Helvetica Neue',Arial; }
    header{ display:flex; align-items:center; gap:18px; border-bottom:2px solid var(--border); padding-bottom:16px; }
    .logo{ width:90px; height:90px; border:1px dashed var(--border); display:flex; align-items:center; justify-content:center; border-radius:10px; font-weight:700; color:var(--muted); background:linear-gradient(180deg,#fff,#f8fafc); overflow:hidden; }
    .logo img{ width:100%; height:100%; object-fit:contain; }
    .company{ flex:1; }
    .company h1{ margin:0; font-size:22px; letter-spacing:.3px; }
    .company p{ margin:.2rem 0; color:var(--muted); }
    .meta{ text-align:right; min-width:240px; }
    .meta h2{ margin:0; color:var(--primary); font-size:20px; }
    .meta .code{ font-weight:700; }
    .grid{ display:grid; grid-template-columns:1fr 1fr; gap:14px; margin:16px 0 8px; }
    .card{ border:1px solid var(--border); border-radius:10px; padding:12px 14px; background:#fff; }
    .card h3{ margin:0 0 6px; font-size:14px; color:#111827; }
    .card p{ margin:.2rem 0; color:var(--muted); }
    table{ width:100%; border-collapse:collapse; margin-top:14px; font-size:13px; border:1px solid var(--border); border-radius:10px; overflow:hidden; }
    thead th{ text-align:left; background:#f3f4f6; color:#111827; font-weight:600; padding:10px; border-bottom:1px solid var(--border); }
    tbody td{ padding:9px 10px; border-bottom:1px solid var(--border); vertical-align:top; }
    tbody tr:nth-child(odd){ background:var(--stripe); }
    tfoot td{ padding:8px 10px; border-top:1px solid var(--border); }
    .right{text-align:right}
    .totals{ margin-top:10px; display:grid; grid-template-columns:1fr 320px; gap:12px; align-items:start; }
    .summary{ border:1px solid var(--border); border-radius:10px; padding:12px 14px; background:#fff; }
    .summary .row{ display:flex; justify-content:space-between;  border-bottom:1px dashed var(--border);flex-wrap: nowrap; }
    .summary .row:last-child{ border-bottom:none; }
    .summary .row.total{ font-size:16px; font-weight:800; color:#111827; }
    .notes{ margin-top:14px; border:1px solid var(--border); border-radius:10px; padding:12px 14px; background:#fff; color:var(--muted); }
    .sign{ display:grid; grid-template-columns:1fr 1fr; gap:18px; margin-top:30px; }
    .sign .line{ border-top:1px solid var(--border); padding-top:8px; text-align:center; color:var(--muted); }
    .actions{ display:flex; gap:8px; justify-content:flex-end; margin-top:10px; }
    .btn{ appearance:none; border:1px solid var(--border); background:#fff; padding:8px 12px; border-radius:8px; cursor:pointer; }
    .btn.primary{ background:var(--primary); border-color:var(--primary); color:#fff; }
    @media print{
      .page{ border:none; border-radius:0; padding:0; margin:0; }
      .actions{ display:none !important; }
      thead{ display:table-header-group; }
      tbody{ display:table-row-group; }
    }
  `;

    const obtenerDatos = async (e) => {
        let response = await fetch(Api + "Pacientes/ListaPedidoID/"+ parseInt(e));
        if (response.ok) {
            let data = await response.json();
            SetListado(data[0])
           
            obtenerDatosLineas(data[0].facturaID)
            obtenerDatosClientes(data[0].clienteID)
            obtenerDatosEmpresa(data[0].empresaID)
            obtenerDatosSN(data[0].tipoComprobante)
            obtenerUsuarios(data[0].creadoPor)

            var subt = data[0].subTotal;
            SubTotal = currencyFormatter({
                currency: "USD",
               value: subt
            })
        }
    }

    const obtenerDatosLineas = async (pl) => {
        let response = await fetch(Api + "Pacientes/ListaPedidoLineasF/" + pl);
        if (response.ok) {
            let data = await response.json()
            SetListadoLineas(data)

       
        }
    }

    const obtenerDatosClientes = async (c) => {
        let response = await fetch(Api + "VentasMantenimiento/ListaClientesID/"+ c);

        if (response.ok) {
            let data = await response.json()
         SetListadoClientes(data[0])
        }
    }
    const obtenerDatosEmpresa = async (e) => {
        let response = await fetch(Api + "Administracion/ListaEmpresas/" + e);
        if (response.ok) {
            let data = await response.json();
            var d = data.filter(x => x.empresaID == e).map(e => e)
            SetEmpresa(d[0])
        }
    }

    const fetchImage = async () => {
        const response = await fetch(Api + "Administracion/MostraFoto/" + emp);
        const blob = await response.blob();
        setImageSrc(URL.createObjectURL(blob));
    };


    const obtenerUsuarios = async (u) => {
        let response = await fetch(Api + "usuario/Lista/1");

        if (response.ok) {
            let data = await response.json()
            let fd = data.filter(x => x.correo == u).map(x => x)
            if (u != 'admin@gmail.com') {
                impresion = fd[0].impresionPuntoVenta;
                Leatendio = fd[0].nombre;
            }
            SetVerFactura(false)
        }
    }

   // function currencyFormatter({ currency, value }) {
    const currencyFormatter=({ currency, value }) =>{
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            minimumFractionDigits: 2,
            currency
        })
        return formatter.format(value)
    }

    const Imprimir = () => {
        SetVerImprimir(true)
        window.print();
     
    }
    const money = (v) => {

        let locale = "es-DO"


        const n = Number.isFinite(+v) ? +v : 0;

        let out = new Intl.NumberFormat(locale, {
            style: "currency",
            currency: "USD",
            currencyDisplay: "symbol", // a veces algunos locales rinden "US$"
        }).format(n);
        // Quita cualquier “US$” o “USD ” que pudiera aparecer
        //out = out.replace(/US\$\s?/i, Listado.moneda + "$");
        out = out.replace(/US\$\s?/i,  "$");
        return out.trim();

    };
    const { subtotal, discountTotal, tax, total } = useMemo(() => {
        let sub = 0;
        let discount = 0;
        for (const it of items) {
            const qty = Number(it.quantity || 0);
            const price = Number(it.unitPrice || 0);
            const disc = Number(it.discountPercent || 0);
            const line = qty * price;
            const lineDisc = (line * disc) / 100;
            sub += line - lineDisc;
            discount += lineDisc;
        }
    const tx = +(sub * taxRate).toFixed(2);
    const tot = +(sub + tx).toFixed(2);
    return { subtotal: +sub.toFixed(2), discountTotal: +discount.toFixed(2), tax: tx, total: tot };
}, [items, taxRate]);
    const percentLabel = `${Math.round(taxRate * 100)}%`;

    //const dollar = currencyFormatter({
    //    currency: "USD",
    //   Listado.subTotal
    //})

    return (
        
        <div>
         <div onContextMenu={handleContextMenu} >
                <div class="printArea1" style={{ backgroundColor: "none", marginLeft: "50px", marginTop: "50px", width: "900px" }} >
                    <style>{styles}</style>

                    <div className="page">
                        <div className="actions">
                            <button className="btn" onClick={() => window.print()}>Imprimir</button>
                        </div>
                        <header>
                            <div className="logo">
                                <img src={imageSrc} alt="Logo" style={{ width: '200px', height: '150px' }} />
                            </div>
                            <div className="company" >
                                <h2 style={{ textAlign: "left" }} >{Empresa.descripcion}</h2>
                                <p>RNC: {Empresa.rnc}</p>
                                <p>{Empresa.direccion}</p>
                                <p>Tel: {Empresa.telefono} · Email: {Empresa.email}</p>
                            </div>
                            <div className="meta">
                                <h2>Factura</h2>

                                <div><b>Impreso</b></div>
                                <div><b>Fecha:</b>{moment(new Date).format("DD/MM/YYYY")}</div>
                                <div><b>Hora:</b>{moment(new Date).format("HH:mm:SS")}</div>


                            </div>
                        </header>
                    
                        <div className="grid">
                            <div className="card">
                                <h3>Cliente</h3>
                                <div><strong>{Listado.nombreCliente}</strong></div>
                                <div>RNC/Cédula: {Listado.rnc}</div>
                          
                                <div>Tel: {Listado.telefono }</div>
                                <div>Correo: {ListadoClientes.correo}</div>
                                <div>Seguro: {Listado.nombreSeguro}</div>
                                <div>Dirección: {ListadoClientes.direccion}</div>
                            </div>
                            <div className="card">
                                <h3>Factura</h3>
                                <div>{SN}</div>
                                <div hidden={Listado.tipoComprobante == 1}><b>NCF:</b>{Listado.ncf}</div>
                                <div hidden={Listado.tipoComprobante != 1}><b>Factura No:</b>{Listado.ncf}</div>
                                <div hidden={Listado.tipoComprobante == 1}><b>Valido Hasta:</b>{moment(Listado.fechaValido).format("DD/MM/YYYY")}</div>
                                <div><b>Orden No:</b>{Listado.facturaID}</div>
                                <div><b>Fecha:</b>{moment(Listado.fecha).format("DD/MM/YYYY")}</div>
                                <div><b>Condición de pago:</b>{Listado.credito == 0 ? 'Contado' : 'Credito'}</div>


                                <div><b>Moneda:</b>{Listado.moneda} </div>
                            </div>
                        </div>

                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: 40 }}>#</th>
                                    <th>Descripción</th>
                                    <th className="right" style={{ width: 90 }}>Cant.</th>
                                    <th className="right" style={{ width: 120 }}>Precio Unit.</th>
                                    <th className="right" style={{ width: 90 }}>% Desc.</th>
                                    <th className="right" style={{ width: 130 }}>Importe</th>
                                </tr>
                            </thead>
                            <tbody>

                                {ListadoLineas.map((it, idx) => {
                                    const qty = Number(it.cantidad || 0);
                                    const price = Number(it.precio || 0);
                                    const disc = Number(it.discountPercent || 0);
                                    const line = qty * price;
                                    const lineDisc = (line * disc) / 100;
                                    const totalLine = line - lineDisc;
                                    return (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{it.descripcionArticulo}</td>
                                            <td className="right">{qty}</td>
                                            <td className="right">{money(price)}</td>
                                            <td className="right">{disc}</td>
                                            <td className="right">{money(totalLine)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        <div className="totals">
                            <div></div>
                            <div className="summary">

                                <div class="" style={{ width: "30%" }} hidden={!Empresa.itbisIncluido} >
                                    <div hidden={Listado.tipoComprobante != 1} className="row"><div>Subtotal</div><div><strong>{money((Listado.subTotal + Listado.totalITBIS))}</strong></div></div>
                                    <div hidden={Listado.tipoComprobante == 1} className="row"><div>Subtotal</div><div><strong>{money(Listado.subTotal)}</strong></div></div>
                                    <div className="row"><div>Descuento</div><div>{money(Listado.totalDescuento)}</div></div>
                                    <div className="row" hidden={Listado.tipoComprobante == 1}><div>ITBIS ({percentLabel})</div><div>{money(Listado.totalITBIS)}</div></div>

                                    <div className="row total"><div>Total</div><div>{money(Listado.totalPago)}</div>

                                    </div>





                                </div>
                                <div class="" style={{ width: "30%" }} hidden={Empresa.itbisIncluido} >

                                    <div hidden={Listado.tipoComprobante != 1} className="row"><div>Subtotal</div><div><strong>{money((Listado.subTotal + Listado.totalITBIS))}</strong></div></div>
                                    <div hidden={Listado.tipoComprobante == 1} className="row"><div>Subtotal</div><div><strong>{money(Listado.subTotal)}</strong></div></div>
                                    <div className="row"><div>Descuento</div><div>{money(Listado.totalDescuento)}</div></div>
                                    <div className="row" hidden={Listado.tipoComprobante == 1}><div>ITBIS ({percentLabel})</div><div>{money(Listado.totalITBIS)}</div></div>
                                    <div className="row total"><div>Total</div><div>{money(Listado.totalPago)}</div></div>


                                </div>

                            </div>
                        </div>

                        <div className="notes">
                            <strong>Notas / Condiciones:</strong>
                            {Listado.comentario}
                        </div>

                        <div className="sign">
                            <div style={{
                                //borderTop: '2px solid',
                                width: '30%',
                                textAlign: 'center'
                            }}>
                                <img class="card-img-top" src="./imagen/LogoEmpresa/Firma.png" style={{ width: '200px', height: '90px', borderBottom: '2px solid' }} />
                                Firma y sello 
                            </div>

                            <div className="line">Aceptación del cliente</div>
                        </div>


                    </div>
                    </div>
                    </div>
                    </div>



              
                

     
        )

}
export default ImpresionFactura;